import React, { useState, useRef } from 'react';
import { useClickOutside } from 'hooks';
import PropTypes from 'prop-types';
import ls from 'local-storage';
import Icon from 'components/common/Icon';
import { blockTypes } from './blockTypes';

export const ADD_POS_BEGINNING = 'beginning';
export const ADD_POS_END = 'end';

const AddBlockMenu = ({
  style = {},
  onItemSelect,
  excludeTypes = [],
  onClickOutside = () => {},
}) => {
  const containerRef = useRef();
  useClickOutside(containerRef, onClickOutside);

  const [addPosition, setAddPosition] = useState(ls.get('sc-addPosition') || ADD_POS_END);
  const handleAddPositionChange = evt => {
    const val = evt.target.value;
    setAddPosition(val);
    ls.set('sc-addPosition', val);
  };

  return (
    <div ref={containerRef} className="sc-add-block-menu" style={style}>
      <div className="flex-spread p-3">
        <strong>Add new items to:</strong>
        <div>
          <label className="form-radio form-inline mr-3">
            <input
              type="radio"
              value={ADD_POS_BEGINNING}
              checked={addPosition === ADD_POS_BEGINNING}
              onChange={handleAddPositionChange}
            />
            <i className="form-icon" /> Beginning
          </label>
          <label className="form-radio form-inline">
            <input
              type="radio"
              value={ADD_POS_END}
              checked={addPosition === ADD_POS_END}
              onChange={handleAddPositionChange}
            />
            <i className="form-icon" /> End
          </label>
        </div>
      </div>
      <hr className="m-0" />

      {blockTypes.filter(({ slug }) => !excludeTypes.includes(slug)).map(({ slug, label, description, iconName }) => (
        <div key={slug} className="sc-add-block-menu-item" onClick={() => onItemSelect(slug, addPosition)}>
          <div className="icon-container">
            <Icon name={iconName} />
          </div>
          <div>
            <div style={{ textTransform: 'capitalize' }}><strong>{label || slug.replace(/_/g, ' ')}</strong></div>
            <div className="text-meta">{description}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

AddBlockMenu.propTypes = {
  style: PropTypes.object,
  excludeTypes: PropTypes.arrayOf(PropTypes.string),
  onItemSelect: PropTypes.func,
  onClickOutside: PropTypes.func,
};

export default AddBlockMenu;
